// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    lng: 'en', // default language
    fallbackLng: 'en', // fallback language if the selected language file is missing
    resources: {
      en: {
        aboutUs: require('./locales/en/aboutUs.json'),
        action: require('./locales/en/action.json'),
        ActionCardComponent: require('./locales/en/ActionCardComponent.json'),
        CardSummary: require('./locales/en/CardSummary.json'),
        CardWithImage: require('./locales/en/CardWithImage.json'),
        ChatContainer: require('./locales/en/ChatContainer.json'),
        creditRisk: require('./locales/en/creditRisk.json'),
        dataSource: require('./locales/en/dataSource.json'),
        dynamicForm: require('./locales/en/dynamicForm.json'),
        ExplainContainer: require('./locales/en/ExplainContainer.json'),
        forgotPassword: require('./locales/en/forgotPassword.json'),
        ExplorationContainer: require('./locales/en/ExplorationContainer.json'),
        FilterInput: require('./locales/en/FilterInput.json'),
        Footer: require('./locales/en/Footer.json'),
        Form: require('./locales/en/Form.json'),
        InterpretContainer: require('./locales/en/InterpretContainer.json'),
        login: require('./locales/en/login.json'),
        NavigationBar: require('./locales/en/NavigationBar.json'),
        PredictiveContainer: require('./locales/en/PredictiveContainer.json'),
        registration: require('./locales/en/registration.json'),
        accountActivation: require('./locales/en/accountActivation.json'),
        Tabs: require('./locales/en/Tabs.json'),
        upload: require('./locales/en/upload.json'),
        useCase: require('./locales/en/useCase.json'),
        UseCaseCardComponent: require('./locales/en/UseCaseCardComponent.json'),
        useCaseDetails: require('./locales/en/useCaseDetails.json'),
        VisualisationForm: require('./locales/en/VisualisationForm.json'),
        VisualisationtypeModal: require('./locales/en/VisualisationtypeModal.json'),
      },
      fi: {
        aboutUs: require('./locales/fi/aboutUs.json'),
        action: require('./locales/fi/action.json'),
        ActionCardComponent: require('./locales/fi/ActionCardComponent.json'),
        CardSummary: require('./locales/fi/CardSummary.json'),
        CardWithImage: require('./locales/fi/CardWithImage.json'),
        ChatContainer: require('./locales/fi/ChatContainer.json'),
        forgotPassword: require('./locales/fi/forgotPassword.json'),
        creditRisk: require('./locales/fi/creditRisk.json'),
        dataSource: require('./locales/fi/dataSource.json'),
        dynamicForm: require('./locales/fi/dynamicForm.json'),
        ExplainContainer: require('./locales/fi/ExplainContainer.json'),
        ExplorationContainer: require('./locales/fi/ExplorationContainer.json'),
        FilterInput: require('./locales/fi/FilterInput.json'),
        Footer: require('./locales/fi/Footer.json'),
        Form: require('./locales/fi/Form.json'),
        InterpretContainer: require('./locales/fi/InterpretContainer.json'),
        login: require('./locales/fi/login.json'),
        NavigationBar: require('./locales/fi/NavigationBar.json'),
        PredictiveContainer: require('./locales/fi/PredictiveContainer.json'),
        registration: require('./locales/fi/registration.json'),
        accountActivation: require('./locales/fi/accountActivation.json'),
        Tabs: require('./locales/fi/Tabs.json'),
        upload: require('./locales/fi/upload.json'),
        useCase: require('./locales/fi/useCase.json'),
        UseCaseCardComponent: require('./locales/fi/UseCaseCardComponent.json'),
        useCaseDetails: require('./locales/fi/useCaseDetails.json'),
        VisualisationForm: require('./locales/fi/VisualisationForm.json'),
        VisualisationtypeModal: require('./locales/fi/VisualisationtypeModal.json'),
      },
      fr: {
        aboutUs: require('./locales/fr/aboutUs.json'),
        action: require('./locales/fr/action.json'),
        ActionCardComponent: require('./locales/fr/ActionCardComponent.json'),
        CardSummary: require('./locales/fr/CardSummary.json'),
        CardWithImage: require('./locales/fr/CardWithImage.json'),
        ChatContainer: require('./locales/fr/ChatContainer.json'),
        forgotPassword: require('./locales/fr/forgotPassword.json'),
        creditRisk: require('./locales/fr/creditRisk.json'),
        dataSource: require('./locales/fr/dataSource.json'),
        dynamicForm: require('./locales/fr/dynamicForm.json'),
        ExplainContainer: require('./locales/fr/ExplainContainer.json'),
        ExplorationContainer: require('./locales/fr/ExplorationContainer.json'),
        FilterInput: require('./locales/fr/FilterInput.json'),
        Footer: require('./locales/fr/Footer.json'),
        Form: require('./locales/fr/Form.json'),
        InterpretContainer: require('./locales/fr/InterpretContainer.json'),
        login: require('./locales/fr/login.json'),
        NavigationBar: require('./locales/fr/NavigationBar.json'),
        PredictiveContainer: require('./locales/fr/PredictiveContainer.json'),
        registration: require('./locales/fr/registration.json'),
        accountActivation: require('./locales/fr/accountActivation.json'),
        Tabs: require('./locales/fr/Tabs.json'),
        upload: require('./locales/fr/upload.json'),
        useCase: require('./locales/fr/useCase.json'),
        UseCaseCardComponent: require('./locales/fr/UseCaseCardComponent.json'),
        useCaseDetails: require('./locales/fr/useCaseDetails.json'),
        VisualisationForm: require('./locales/fr/VisualisationForm.json'),
        VisualisationtypeModal: require('./locales/fr/VisualisationtypeModal.json'),
      }
    },
    ns: [
        'aboutUs',
        'action',
        'ActionCardComponent',
        'CardSummary',
        'CardWithImage',
        'ChatContainer',
        'creditRisk',
        'dataSource',
        'dynamicForm',
        'ExplainContainer',
        'ExplorationContainer',
        'FilterInput',
        'Footer',
        'Form',
        'InterpretContainer',
        'login',
        'NavigationBar',
        'PredictiveContainer',
        'registration',
        'Tabs',
        'upload',
        'useCase',
        'UseCaseCardComponent',
        'useCaseDetails',
        'VisualisationForm',
        'VisualisationtypeModal',
    ], // namespaces for each file
    defaultNS: 'home', // default namespace
    interpolation: {
      escapeValue: false, // react already handles escaping
    },
  });

export default i18n;
